import useOutsideClick from "hooks/click-outside";
import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { ReactComponent as ScanIcon } from "assets/images/svgs/scan.svg";

const ScannerCameraPopup = ({ isOpen, onClose, handleOpenCamera }) => {
  const modalRef = useOutsideClick(onClose);

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      style={{ zIndex: 'calc(var(--z-modal) + 1)' }}
    >
      <div
        ref={modalRef}
        className={`relative bg-white px-6 py-8 rounded-lg shadow-lg w-[95%] sm:w-[60%] md:w-[700px] transform transition-transform duration-300 ${
          isOpen ? "scale-100" : "scale-95"
        }`}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
        >
          <AiOutlineClose size={20} />
        </button>

        <h2 className="text-xl font-bold text-center text-blackie mb-3">
          Select Scanner or Camera Mode
        </h2>
        <p className="text-lg text-center text-blackie mb-5">
          You need to plug scanner in order to scan and if you are using mobile,
          we require camera permission.
        </p>

        <div className="flex flex-wrap justify-center  gap-6 items-center">
          {/* <div className="flex flex-col justify-center items-center gap-2">
            <h3 className="font-semibold text-blackie text-center">
              Scanner (External device)
            </h3>
            <p className="text-sm text-rsvpGreen text-center">
              Plug in scanner device to use this feature
            </p>
            <button className="mt-2 bg-rsvpgray text-white px-4 py-2 rounded-full  w-fit flex items-center justify-center gap-2">
              <ScanIcon />
              <span>Use Scanner</span>
            </button>
          </div> */}
          <div className="flex flex-col justify-center items-center gap-2">
            <h3 className="font-semibold text-blackie text-center">Camera</h3>
            <p className="text-sm text-rsvpGreen text-center">
              Allow Camera for this device to scan
            </p>
            <button
              onClick={handleOpenCamera}
              className="mt-2 bg-rsvpGreen text-white px-4 py-2 w-fit rounded-full flex items-center justify-center gap-2"
            >
              <ScanIcon />
              <span>Use Camera</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScannerCameraPopup;
